import { render, staticRenderFns } from "./ListTextLoading.vue?vue&type=template&id=8daf87f0&"
import script from "./ListTextLoading.vue?vue&type=script&lang=js&"
export * from "./ListTextLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports